/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import { commonConstants } from '../constants';

function userDetails(state = {}, action) {
  if (action.type === commonConstants.SET_LOGIN_USER) {
    return action.user;
  } else {
    return state;
  }
}

function userAuthorizationDetails(state = {}, action) {
  if (action.type === commonConstants.SET_USER_AUTHORIZATIONS) {
    return action.userAuth;
  } else {
    return state;
  }
}

export { userDetails, userAuthorizationDetails };
